import { useState } from "react";
import { ENUM_CASHBACK_STATUS, ENUM_STATUS_FOR_USER, ENUM_USER_ACTIVE } from "../../store/enums";
import { infoToast } from "../../components/mui/Toaster";
import { dispatchCusEvent } from "../../utils/utils";
import { ENUM_COMMON_EVENT } from "../common/useListener";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/index.ts";

export default function useBonusHelper() {
  const { t } = useTranslation();
  const isAuth = useAppSelector((state) => state.user.isAuth);

  const [btnLoading, setBtnLoading] = useState(false);
  const thenRequest = (status) => {
    return new Promise((rs) => {
      const toastText =
        status === ENUM_USER_ACTIVE.disabled
          ? "You declined the bonus"
          : "Bonus successfully activated";

      infoToast(t(toastText));

      dispatchCusEvent(ENUM_COMMON_EVENT.getBonus, {
        successFn: () => {
          setBtnLoading(false);
          rs();
        }
      });
    });
  };

  const btnTextByStatus = (activeStatus, statusForUser, type) => {
    if (!isAuth) return "Activate";
    if (activeStatus === ENUM_USER_ACTIVE.disabled) return "Unavailable";
    if (activeStatus === ENUM_USER_ACTIVE.activated) {
      if (type == "cashback") return "Deactivate";
      if (statusForUser === ENUM_STATUS_FOR_USER.accrued) return "Refuse the bonus";
      if (statusForUser === ENUM_STATUS_FOR_USER.enabled) return "Refuse the bonus";
      // if (statusForUser === ENUM_STATUS_FOR_USER.enabled) return "Deactivate";
      if (
        [
          ENUM_CASHBACK_STATUS.waitActivate,
          ENUM_CASHBACK_STATUS.waitWeekDay,
          ENUM_CASHBACK_STATUS.waitWelcome
        ].includes(statusForUser)
      )
        return "Deactivate";
    }
    if (activeStatus === ENUM_USER_ACTIVE.wait) return "Activate";

    return "Error status";
  };

  const getSendStatus = (status) =>
    status === ENUM_USER_ACTIVE.activated ? ENUM_USER_ACTIVE.disabled : ENUM_USER_ACTIVE.activated;

  return { btnLoading, setBtnLoading, thenRequest, btnTextByStatus, getSendStatus };
}
